import { BGRorB, BGRorB_Thumb } from "../../../../../assets";
import { IMiniGameProps } from "../../../../../../typings/common";
import BonusGameCard from "./BonusGameCard";

function BGBlackAndRedGame({
  isSmall,
  onStartGame,
  config,
  miniGameData,
  playerLevel,
}: IMiniGameProps) {
  return (
    <BonusGameCard
      isSmall={isSmall}
      onStartGame={onStartGame}
      config={config}
      miniGameData={miniGameData}
      playerLevel={playerLevel}
      titleSource={BGRorB}
      thumbSource={BGRorB_Thumb}
      launchPath="/blackAndRed/bowaPlayer.html"
      cooldownHours={4}
      freePlayTitleFontSize={12}
      infoPaddingVertical={2}
    />
  );
}

export default BGBlackAndRedGame;
